const data = (collection, keyword, team, template) => (
  collection
    && Object.values(collection).filter((item) => {
      let available = false;
      if (
        item.attributes.full_name
          .toLowerCase()
          .includes(keyword.toLowerCase())
        && (team == ''
          || (team != ''
            && item.attributes.team_id.toString() == team.toString()))
        && (template == ''
          || (template != ''
            && item.attributes.programs
              .map((item) => parseInt(item.template_id))
              .includes(parseInt(template))))
      ) available = true;

      return available;
    })
);

export default data;
